import {
  CREATE_USER_API_KEY,
  FETCH_USER_INFO_REQUEST,
  FETCH_USER_INFO_RESPONSE
} from '../constants/action-types'

const userInfoReducer = (
  state = {
    isFetchingUserInfo: false,
    fetchUserInfoError: false,
    userInfoData: null
  },
  action
) => {
  switch (action.type) {
    case CREATE_USER_API_KEY: {
      const { userInfoData } = state
      const developerKeys = userInfoData.developer_keys || []
      const newDeveloperKeys = [...developerKeys, action.payload.data]
      const newUserInfoData = Object.assign({}, userInfoData, {
        developer_keys: newDeveloperKeys
      })
      return Object.assign({}, state, {
        developerKeyError: action.error,
        userInfoData: newUserInfoData
      })
    }
    case FETCH_USER_INFO_REQUEST:
      return Object.assign({}, state, {
        isFetchingUserInfo: true
      })
    case FETCH_USER_INFO_RESPONSE:
      return Object.assign({}, state, {
        isFetchingUserInfo: false,
        fetchUserInfoError: action.error,
        userInfoData: action.payload.data
      })
    default:
      return state
  }
}

export default userInfoReducer



// WEBPACK FOOTER //
// ./src/reducers/user-info-reducer.js